module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.StepId == 1),
      expression: "StepId==1"
    }],
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "归属方:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.AgentStyleName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属代理商:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.agent) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课园所:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.school) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.PackageName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课班级数:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.ClassNum) + "\n            ")]), _vm._v(" "), _vm._l((_vm.form.ClassList), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": '班级' + (index + 1) + ':'
      }
    }, [_vm._v("\n                " + _vm._s(item.ClassName) + "\n            ")])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配套课程"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.courses,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "课程类型",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配套物料:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.materiel,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.IsUseAgentStock == 2),
      expression: "form.IsUseAgentStock==2"
    }],
    attrs: {
      "label": "是否使用经销商库存发货:",
      "label-width": "170px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.IsUseAgentStockName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.IsUseAgentStock == 1),
      expression: "form.IsUseAgentStock==1"
    }],
    attrs: {
      "label": "请选择使用库存代理商:",
      "label-width": "160px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.ChooseAgentName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.IsUseAgentStock == 1),
      expression: "form.IsUseAgentStock==1"
    }],
    attrs: {
      "label": "使用经销库存发货数:",
      "label-width": "160px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.stockNum) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单价格:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.form.OrderPrice) + "元")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("物流")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式:",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v("寄付（送货）")])]), _vm._v(" "), _vm._l((_vm.form.ListMeetPay), function(item, index) {
    return _c('el-row', [_c('el-form-item', {
      attrs: {
        "label": '支付方式-' + (index + 1)
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayWayName))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PayWay !== 6 && item.PayWay !== 9),
        expression: "item.PayWay!==6&&item.PayWay!==9"
      }],
      attrs: {
        "label": "支付金额："
      }
    }, [_c('span', [_vm._v(_vm._s(item.OrderActualPrice))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.VoucherPic.length > 0),
        expression: "item.VoucherPic.length>0"
      }],
      attrs: {
        "label": "支付凭证"
      }
    }, _vm._l((item.VoucherPic), function(item2) {
      return _c('div', {
        attrs: {
          "id": "ImgPrev"
        }
      }, [_c('div', {
        staticClass: "post-format-content"
      }, [_c('div', {
        staticClass: "post-thumbnail"
      }, [_c('img', {
        staticClass: "attachment-thumbnail wp-post-image",
        attrs: {
          "id": "myProPic",
          "src": item2.Url
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content-wrap"
      }, [_c('span', {
        staticClass: "entry-title"
      }, [_c('span', {
        staticClass: "featured-image",
        on: {
          "click": function($event) {
            _vm.showImgView(item2)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-view"
      })])])])])])
    })), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.Trade_No !== ''),
        expression: "item.Trade_No!==''"
      }],
      attrs: {
        "label": "支付凭证单号："
      }
    }, [_c('span', [_vm._v(_vm._s(item.Trade_No))])]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PayWay == 8),
        expression: "item.PayWay==8"
      }],
      attrs: {
        "label": "支付说明："
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayRemark))])])], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.OrderRemark) + "\n            ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.AddDialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("查看园所信息页面")])], 1)], 1)], 2), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.StepId == 2),
      expression: "StepId==2"
    }],
    attrs: {
      "model": _vm.netWorkData,
      "label-width": "170px"
    }
  }, [_c('h4', [_vm._v("网络情况")]), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所网络运营商："
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.netWorkData.NetworkOperator),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "NetworkOperator", $$v)
      },
      expression: "netWorkData.NetworkOperator"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("移动")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("电信")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("联通")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 8
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所网络情况："
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.netWorkData.NetworkType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "NetworkType", $$v)
      },
      expression: "netWorkData.NetworkType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("有线")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("无线")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.netWorkData.Distance !== 0),
      expression: "netWorkData.Distance!==0"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电视到宽带口距离多远："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.netWorkData.Distance),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "Distance", $$v)
      },
      expression: "netWorkData.Distance"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("10米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("30米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("50米")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 8
    }
  }, [_vm._v("100米以上")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否需要上门服务："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.netWorkData.Engineer),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "Engineer", $$v)
      },
      expression: "netWorkData.Engineer"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("需要工程师上门")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("不需要,自己解决网络")])], 1)], 1)], 1)], 1), _vm._v(" "), (true) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所照片："
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "display": "block"
    }
  }, [_vm._v("(需上传带Logo及园所名称的照片)")]), _vm._v(" "), _c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.SchoolPics), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "签约方证明："
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "display": "block"
    }
  }, [_vm._v("(三证任选其一)")]), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.netWorkData.ProveType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "ProveType", $$v)
      },
      expression: "netWorkData.ProveType"
    }
  }, [_vm._v("办园许可证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.netWorkData.ProveType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "ProveType", $$v)
      },
      expression: "netWorkData.ProveType"
    }
  }, [_vm._v("民办许可证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.netWorkData.ProveType),
      callback: function($$v) {
        _vm.$set(_vm.netWorkData, "ProveType", $$v)
      },
      expression: "netWorkData.ProveType"
    }
  }, [_vm._v("园长身份证 ")]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.netWorkData.ProveType == 2),
      expression: "netWorkData.ProveType==2"
    }],
    staticStyle: {
      "color": "red",
      "display": "block"
    }
  }, [_vm._v("(身份证最少上传两张，照片面和国徽面)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.ProvePics), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.ContractPices), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开课申请表："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.netWorkData.CooperationPics), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.backFn
    }
  }, [_vm._v("返回上一步")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fe9e3d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/D55OrderView/index.vue
// module id = 1467
// module chunks = 1